import { hdmgdjFeatures } from "@/mocks/hdmgdj/features";

const iconTone: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-800",
};

/** 前 5 张卡片的 bento 跨度：7+5 / 4+4+4 */
const spans = ["lg:col-span-7", "lg:col-span-5", "lg:col-span-4", "lg:col-span-4", "lg:col-span-4"];

export default function HdmgdjFeatures() {
  return (
    <section id="hdmgdj-features" className="w-full bg-background-50 py-16 md:py-24">
      <div className="hdmgdj-container">
        <div className="hdmgdj-reveal max-w-2xl">
          <span className="inline-flex items-center gap-2 text-primary-700 text-[14px] font-label font-bold">
            <i className="ri-stack-line text-lg" />
            核心功能
          </span>
          <h2 className="mt-3 font-heading text-foreground-950 text-[30px] md:text-[44px] leading-tight">
            为什么大家都在用
            <span className="text-primary-600"> 黄豆魔改短剧</span>
          </h2>
          <p className="mt-4 text-[15px] md:text-[16px] leading-8 text-foreground-600">
            {"从内容到体验，我们只做一件事：让你打开就停不下来。"}
          </p>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-5">
          {hdmgdjFeatures.map((feature, index) => {
            const dark = index === 0;
            return (
              <article
                key={feature.id}
                className={`hdmgdj-reveal rounded-lg p-6 md:p-7 transition-colors ${spans[index] ?? "lg:col-span-4"} ${
                  dark
                    ? "bg-foreground-950 border border-foreground-900"
                    : "bg-background-100 border border-background-200 hover:border-primary-300"
                }`}
                style={{ transitionDelay: `${(index % 3) * 70}ms` }}
              >
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-lg text-2xl ${
                    dark ? "bg-primary-500 text-foreground-950" : iconTone[feature.tone]
                  }`}
                >
                  <i className={feature.icon} />
                </span>
                <h3
                  className={`mt-5 font-label font-bold ${
                    dark ? "text-background-50 text-[19px] md:text-[22px]" : "text-foreground-950 text-[17px]"
                  }`}
                >
                  {feature.title}
                </h3>
                <p
                  className={`mt-2.5 leading-7 ${
                    dark ? "text-background-200 text-[14px] md:text-[15px] max-w-xl" : "text-foreground-600 text-[14px]"
                  }`}
                >
                  {feature.desc}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}